export const validationMessages = {
  email: "Email address is required.",
  password: "Password is required.",
};
